﻿export default {
  "rounds": 1,
  "seed": "473069f7ef1027b450f3fcc7540ecdef51d62070c7bd0acb1023922b8aa5c8e784295e237071d79a862ce2003d569f13252554292afaa3be2d7b2cdde9f1abc2"
};